import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "prompts-list" }
const _hoisted_3 = {
  key: 1,
  class: "prompts-content"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "highlight ellipsis" }
const _hoisted_7 = { class: "prompt ellipsis" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_Empty = _resolveComponent("Empty")
  const _component_Highlight = _resolveComponent("Highlight")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#chat",
    min_width: "49.5rem",
    max_width: "49.5rem"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createTextVNode(" Saved Prompts ")),
        _createVNode(_component_Icon, {
          class: "pointer",
          icon: "x-close",
          stroke: "var(--gray-400)",
          height: "2rem",
          width: "2rem",
          onClick: _withModifiers($options.closeAll, ["stop"])
        }, null, 8 /* PROPS */, ["onClick"])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SearchInput, {
          ref: "search",
          class: "search",
          placeholder: "Search prompts",
          disabled: $options.empty && !$data.search,
          minlength: 2,
          "always-show": "",
          delay: 200,
          onSearch: _cache[0] || (_cache[0] = $event => ($data.search = $event))
        }, null, 8 /* PROPS */, ["disabled"]),
        _createVNode(_component_ScrollBar, {
          class: "scroller",
          fade: ""
        }, {
          default: _withCtx(() => [
            ($options.empty)
              ? (_openBlock(), _createBlock(_component_Empty, {
                  key: 0,
                  bordered: false,
                  class: "empty",
                  "bg-size": "36rem",
                  "circle-size": "7.6rem"
                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                  ($data.search)
                    ? {
                        name: "sub-text",
                        fn: _withCtx(() => [
                          _cache[3] || (_cache[3] = _createTextVNode(" There are no prompts matching your criteria")),
                          _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                          _createElementVNode("a", {
                            class: "pointer",
                            onClick: _cache[1] || (_cache[1] = (...args) => ($options.clearSearch && $options.clearSearch(...args)))
                          }, "Clear search")
                        ]),
                        key: "0"
                      }
                    : {
                        name: "sub-text",
                        fn: _withCtx(() => [
                          _cache[5] || (_cache[5] = _createTextVNode(" Your prompt list is empty. ")),
                          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                          _cache[7] || (_cache[7] = _createTextVNode(" You can add prompts to reuse them later "))
                        ]),
                        key: "1"
                      },
                  ($data.search)
                    ? {
                        name: "image",
                        fn: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            width: "4rem",
                            height: "4rem",
                            icon: "search",
                            class: "icon-svg",
                            stroke: "var(--brand-500)"
                          })
                        ]),
                        key: "2"
                      }
                    : undefined
                ]), 1024 /* DYNAMIC_SLOTS */))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.c_prompts, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "prompt-item pointer",
                      onClick: $event => ($options.selectPrompt(item))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_Highlight, {
                            text: item.title,
                            highlight: $data.search
                          }, null, 8 /* PROPS */, ["text", "highlight"])
                        ]),
                        _createVNode(_component_IconAsButton, {
                          class: "action",
                          tooltip: "Share prompt",
                          icon: "share-06",
                          stroke: "#414651",
                          size: "1.6rem",
                          onClick: _withModifiers($event => ($options.sharePrompt(item.id)), ["stop"])
                        }, null, 8 /* PROPS */, ["onClick"]),
                        _createVNode(_component_IconAsButton, {
                          class: "action",
                          tooltip: "Edit prompt",
                          icon: "pencil-01",
                          size: "1.6rem",
                          onClick: _withModifiers($event => ($options.editPrompt(item)), ["stop"])
                        }, null, 8 /* PROPS */, ["onClick"]),
                        _createVNode(_component_IconAsButton, {
                          class: "action",
                          tooltip: "Delete prompt",
                          icon: "trash-01",
                          size: "1.6rem",
                          color: "--brand-600",
                          onClick: _withModifiers($event => ($options.deletePrompt(item.id)), ["stop"])
                        }, null, 8 /* PROPS */, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_Highlight, {
                          text: item.prompt,
                          highlight: $data.search
                        }, null, 8 /* PROPS */, ["text", "highlight"])
                      ])
                    ], 8 /* PROPS */, _hoisted_4))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        primary: "",
        class: "create-btn",
        onClick: $options.onCreate
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, {
            icon: "package-plus",
            width: "2rem",
            height: "2rem",
            stroke: "var(--base-white)"
          }),
          _cache[8] || (_cache[8] = _createTextVNode(" Create New Prompt "))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}